import ContentCard from './content-card'

export default ContentCard
